import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxIndeterminate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_checkbox_indeterminate_fixed",
			x1: 0,
			y1: 0,
			x2: 1,
			y2: 0,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4B8DEA" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#616CE0"
			})]
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 2,
			fill: "url(#paint0_linear_checkbox_indeterminate_fixed)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12H17",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgCheckboxIndeterminate;
